import { makeStyles } from '@material-ui/core/styles'
import { Slider, withStyles } from '@material-ui/core'

const useStyles = makeStyles(
	theme => ({
		labels: {
			margin: theme.spacing(-0.5, 0, 0),
			paddingBottom: theme.spacing(2),
		},
		label: {
			width: '30%',
			flexGrow: 1,
			'&:nth-child(2)': {
				textAlign: 'center',
			},
			'&:last-child': {
				textAlign: 'right',
			},
		},
	}),
	{ name: 'Questions-AnswerTypes-Slider' },
)

export const ScoreSlider = withStyles(
	theme => ({
		root: {
			height: 8,
		},
		thumb: {
			height: 20,
			width: 20,
			backgroundColor: theme.palette.common.white,
			boxShadow: '0 -2px 4px rgba(140, 140, 140, 0.2), 0 2px 4px rgba(140, 140, 140, 0.2)',
			marginTop: -8,
			marginLeft: -10,
			'&:focus, &:hover, &$active': {
				boxShadow: '0 -2px 4px rgba(140, 140, 140, 0.2), 0 2px 4px rgba(140, 140, 140, 0.2)',
			},
			'&:after': {
				top: -6,
				left: -6,
				right: -6,
				bottom: -6,
			},
		},
		mark: {
			height: 0,
		},
		active: {},
		valueLabel: {
			left: 'calc(-50% + 3px)',
			top: -35,
			fontSize: theme.typography.body1.fontSize,
			'& > span': {
				width: 34,
				height: 34,
			},
		},
		track: {
			height: 8,
			borderRadius: 4,
		},
		rail: {
			height: 8,
			borderRadius: 4,
			backgroundColor: '#D7D8E0',
		},
	}),
	{ name: 'Question-Slider' },
)(Slider)

export default useStyles
